import { call, put, takeLatest } from 'typed-redux-saga'
import { dictsApi, dictsSlice } from 'Modules'

function* getAll() {
	try {
		const res = yield* call(dictsApi.getAll)
		yield* put(dictsSlice.actions.setAll(res))
	} catch (errors) {
		/* eslint-disable-next-line */
		console.log('Dicts errors: ', errors)
	}
}

export function* dictsSaga() {
	yield* takeLatest(dictsSlice.actions.getAll.type, getAll)
}
